import { create } from 'zustand';

export type ThemeType = 'dark' | 'light';

type ThemeStore = {
  theme: ThemeType;
  setTheme: (theme: ThemeType) => void;
};

const isDarkMode =
  typeof window !== 'undefined' ? window.__darkMode__ : global.__darkMode__;

export const useThemeStore = create<ThemeStore>((set) => ({
  theme: isDarkMode ? 'dark' : 'light',
  setTheme: (theme) => set({ theme }),
}));
